<template>
  <ReportingSettings
    :available-filters="availableCallLogsFilters"
    :default-title="$t('DEFAULT_CALL_LOGS_TITLE')"
    :active-report="activeCallLog"
    :report-type="reportType"
    :time-range="activeCallLogTimeRange"
    :time-zone-id="activeCallLogTimeZoneId"
    :translated-time-zone-id="activeCallLogTranslatedTimeZoneId"
    :last-updated="activeCallLogLastUpdated"
    :filter-criteria="activeCallLogFilterCriteria"
    :view-as="activeCallLogViewAs"
    :view-as-publishers="viewAsPubs"
    :view-as-buyers="viewAsBuyers"
    :view-as-buyer-managers="viewAsBuyerManagers"
    :view-as-pub-managers="viewAsPubManagers"
    :quick-filters="callLogsQuickFilters"
    form-name-for-user-settings="reportingCallLogFilterUserSettings"
    @saveReport="saveCallLogReport"
    @deleteReport="deleteCallLogReport"
    @duplicateReport="duplicateCallLogReport"
    @refreshData="refreshCallLogsData"
    @dateRangeChange="$emit('dateRangeChange')"
    @viewAsChange="viewAsChange"
    @onStartTour="$emit('onStartTour')"
  />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import messages from './locales';
import { $ngStateService, utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import ReportingSettings from '../../ReportingSettings/ReportingSettings';
import { CALLLOG_REPORT_TYPE } from '@/modules/reporting/store/state';


export default {
  name: 'ReportingCallLogsSettings',
  components: {
    ReportingSettings
  },
  data() {
    return {
      reportType: CALLLOG_REPORT_TYPE
    };
  },
  computed: {
    ...mapGetters('reporting', [
      'availableCallLogsFilters',
      'activeCallLog',
      'activeCallLogTimeRange',
      'activeCallLogTimeZoneId',
      'activeCallLogTranslatedTimeZoneId',
      'activeCallLogLastUpdated',
      'activeCallLogFilterCriteria',
      'activeCallLogViewAs',
      'callLogsQuickFilters'
    ]),
    ...mapGetters([
      'isAdmin',
      'isReadOnlyReportUser'
    ]),
    ...mapState([
      'affiliates',
      'buyers'
    ]),
    ...mapState('userGroups', ['userGroups']),
    isNew() {
      return !this.activeCallLog.id;
    },
    enableViewAs() {
      return this.isAdmin || this.isReadOnlyReportUser;
    },
    viewAsPubs() {
      if(this.enableViewAs) {
        return this.affiliates;
      }

      return [];
    },
    viewAsBuyers() {
      if(this.enableViewAs) {
        return this.buyers;
      }

      return [];
    },
    viewAsBuyerManagers() {
      if(this.enableViewAs) {
        return this.userGroups.filter(m => m.type == 'Buyer');
      }

      return [];
    },
    viewAsPubManagers() {
      if(this.enableViewAs) {
        return this.userGroups.filter(m => m.type == 'Affiliate');
      }

      return [];
    }
  },
  created() {
    if (this.enableViewAs) {
      this.getBuyers();
      this.getAffiliates();
      this.getUserGroups();
    }
  },
  methods: {
    ...mapActions('reporting', [
      'saveReport',
      'deleteReport',
      'duplicateReport',
      'setSavedReportVisibility',
      'setCallLogsViewAs'
    ]),
    ...mapActions([
      'getBuyers',
      'getAffiliates'
    ]),
    ...mapActions('userGroups', ['getUserGroups']),
    async saveCallLogReport(visibleAccountWide) {
      const isNewCallLog = this.isNew;

      if(isNewCallLog) {
        this.setSavedReportVisibility({
          reportType: CALLLOG_REPORT_TYPE,
          visibleAccountWide
        });
      }

      try {
        await this.saveReport(this.activeCallLog);

        if(isNewCallLog) {
          utilities.showToaster('success', this.$i18n.t('CALL_LOGS_SAVE_SUCCESS'));
          this.routeToNewCallLog();
        } else {
          utilities.showToaster('success', this.$i18n.t('CALL_LOGS_UPDATE_SUCCESS'));
        }

        document.title = this.activeCallLog.name;
      } catch (error) {
        utilities.errorHandler(error);
      }

    },
    async deleteCallLogReport() {
      await this.deleteReport(this.activeCallLog.id);
      utilities.showToaster('success', this.$i18n.t('CALL_LOGS_DELETE_SUCCESS'));

      $ngStateService.go('dashboard.call-logs.create-report');
    },
    async duplicateCallLogReport(visibleAccountWide) {
      this.setSavedReportVisibility({
        reportType: CALLLOG_REPORT_TYPE,
        visibleAccountWide
      });

      await this.duplicateReport(this.activeCallLog);

      utilities.showToaster('success', this.$i18n.t('CALL_LOGS_DUPLICATE_SUCCESS'));

      document.title = this.activeCallLog.name;

      this.routeToNewCallLog();
    },
    routeToNewCallLog() {
      $ngStateService.go('dashboard.call-logs.report', {
        reportId: this.activeCallLog.id
      });
    },
    refreshCallLogsData() {
      this.$emit('refreshCallLogsData');
    },
    viewAsChange(viewAs) {
      this.setCallLogsViewAs(viewAs);
    }
  },
  i18n: {
    locale: 'en',
    messages
  }
};
</script>

<style>

</style>